import * as actionTypes from "./actionTypes";

export const setCursor =()=>{
    return {
        type:actionTypes.SET_CURSOR,
    };
};
